module.exports = __webpack_public_path__ + "img/Dantam Makeover 03.df2e37ad.jpg";